import {
	ADD_COMMENT,
	ADD_NFT,
	ADD_POST,
	ADD_POST_ERROR,
	DELETE_COMMENT,
	DELETE_POST,
	GET_POSTS,
	SET_POSTS_DATA,
} from "./constants";

export function addPost(post, cbSuccess) {
	return {
		type: ADD_POST,
		post,
		cbSuccess,
	};
}
export function setPostError(error) {
	return {
		type: ADD_POST_ERROR,
		error,
	};
}
export function getPost(page, username, query, isVisiting) {
	return {
		type: GET_POSTS,
		page,
		username,
		query,
		isVisiting,
	};
}
export function setPostData(data) {
	return {
		type: SET_POSTS_DATA,
		data,
	};
}
export function addNft(data, cbSuccess, cbFailed) {
	return {
		type: ADD_NFT,
		data,
		cbSuccess,
		cbFailed,
	};
}
export function deletePost(postId, cbSuccess) {
	return {
		type: DELETE_POST,
		postId,
		cbSuccess,
	};
}
export function addCommentAction(parentId, isFromPost, comment, cbSuccess) {
	return {
		type: ADD_COMMENT,
		parentId,
		isFromPost,
		comment,
		cbSuccess,
	};
}
export function deleteCommentAction(commentId, cbSuccess) {
	return {
		type: DELETE_COMMENT,
		commentId,
		cbSuccess,
	};
}
